import { render, staticRenderFns } from "./NewGroupType.vue?vue&type=template&id=9f6d36d2"
import script from "./NewGroupType.vue?vue&type=script&lang=js"
export * from "./NewGroupType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports